import React from 'react';
import { ListButton, SaveButton, Toolbar, useDataProvider, useNotify, useRedirect, useRefresh } from 'react-admin';
import { User } from '../../types/user';
import "./index.css"

const UserToolbar = (props, isCreate, isBlocked) => {
    const location = props.location.pathname.split('/')
    const path = location[location.length - 1]
    const dataProvider = useDataProvider()
    const notify = useNotify()
    const redirect = useRedirect()
    const handleSave = async (data) => {
        data.isBlocked = isBlocked
        try {
            
            const result = isCreate
            ? await dataProvider.create('users/cms', { data: data })
            : await dataProvider.update('users/cms', {
                id: props.id,
                data: data,
                previousData: {} as User
            })
            if (!result.data) {
                notify('something went wrong', "error")
            }
            notify(`User ${isCreate ? 'saved' : 'updated'}`);
            redirect('/users')
        } catch (error) {
           
            notify(error.data? error.data.error: error, "error")
        }
    }
    return (

        <Toolbar {...props} id={path.length !==1 ? "toolbar-flex-end" : "hide-toolbar"}>
            <SaveButton onSave={(data) => handleSave(data)} className="save-button" />
            <ListButton className="cancel-button" label="Cancel"><div>Cancel</div></ListButton>
        </Toolbar>

    )
};

export default UserToolbar